export default "__VITE_ASSET__BrSzbUkb__"